import { createMongoAbility } from '@casl/ability';

const defaultAbilities = [{ action: 'read', subject: 'all' }];
export const ability = createMongoAbility(defaultAbilities);

export const resetAbility = () => ability.update(defaultAbilities);
export default ability;
